export class Gender {

    // 1: F
    // 2: M
    // 3: O

    static Female = 1;
    static Male = 2;
    static Other = 3;

    value: number;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}